<header id="header" class="fixed-top">
	<nav class="navbar navbar-expand-md navbar-light rounded">
		<a class="logo me-auto ms-5" href="https://www.formacionytecnologia.com/motoriaweb/observadores">
			<img src="../../assets/img/motoria/logo-motoria-p.png" alt="logo motoria" />
		</a>

		<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbardesplegable" aria-controls="navbardesplegable" aria-expanded="false" aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		</button>

		<div class="collapse navbar-collapse" id="navbardesplegable">
			<ul class="navbar-nav ms-auto me-5">
				<li>
					<a class="nav-item nav-link scrollto" href="https://www.formacionytecnologia.com/motoriaweb/observadores/producto">
						PRODUCTO
					</a>
				</li>
				<li>
					<a class="nav-item nav-link scrollto" href="https://www.formacionytecnologia.com/motoriaweb/observadores/proyectoredes">
						PROYECTO RED.ES
					</a>
				</li>
				<li>
					<a class="nav-item nav-link scrollto" href="https://www.formacionytecnologia.com/motoriaweb/observadores/contacto">
						CONTACTO
					</a>
				</li>
				<li>
					<a class="nav-item nav-link scrollto" href="https://www.formacionytecnologia.com/motoriaweb/observadores/areaprivada">
						ÁREA PRIVADA
					</a>
				</li>
			</ul>
		</div>
	</nav>
</header>

<div id="motoria-back">
	<nav class="navbar navbar-inverse navbar-no-bg" role="navigation">
		<div class="container">
			<div id="top-navbar-1" class="collapse navbar-collapse"></div>
		</div>
	</nav>

	<div id="motoria-info-login">
		<div class="container">
			<div class="row">
				<div class="col-md-7 cajafondo text text-center">
					<h1 class="animate__animated animate__fadeInLeftBig">
						<p>Crea cursos rápidamente mediante</p>
						<strong>INTELIGENCIA ARTIFICIAL</strong>
					</h1>
					<div class="animate__animated animate__fadeInLeftBig">
						<p>Nunca ha sido tan fácil y rápido crear cursos e-learning</p>
						<p>gracias al uso de tecnologías de Inteligencia Artificial y Big Data.</p>
					</div>
				</div>

				<div class="col-md-5 mt-3 mt-md-0 form-box animate__animated animate__fadeInUp">
					<div class="form-top rounded-top">
						<div class="form-top-left">
							<p>Escribe tu usuario y contraseña</p>
						</div>

						<div class="form-top-right">
							<i class="fas fa-key"></i>
						</div>
					</div>

					<div class="form-bottom rounded-bottom">
						<form [formGroup]="form" (ngSubmit)="login(form)" autocomplete="off">
							<div class="form-group mb-3">
								<!-- <label for="user">Usuario</label> -->
								<input name="user" formControlName="user" autocomplete="off" class="form-control input-sm" placeholder="Usuario" />
							</div>

							<div class="form-group mb-3">
								<!-- <label for="pass">Contraseña</label> -->
								<input type="password" name="pass" formControlName="pass" autocomplete="off" class="form-control input-sm" placeholder="Contraseña" />
							</div>

							<button id="login" type="submit" class="btn btn-link-1 mb-3" [attr.disabled]="loggingIn ? 'disabled' : null">
								<i class="fas fa-sign-in-alt"></i>
								<span>Acceder</span>
							</button>

							<img *ngIf="loggingIn" class="login-spinner" src="../../assets/img/loading.gif" />
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<footer class="footer pt-2">
	<div class="container">
		<section id="clients" class="clients">
			<div class="container aos-init aos-animate" data-aos="zoom-in">
				<div class="row mt-4">
					<div class="col-lg-4 col-md-4">
						<p>Proyecto desarrollado por:</p>
						<img src="https://www.formacionytecnologia.com/motoriaweb/observadores/assets/img/logo_fortec.png" alt="" style="width: 15rem" />
					</div>

					<div class="col-lg-8 col-md-8">
						<p>Proyecto cofinanciado por:</p>
						<img src="https://www.formacionytecnologia.com/motoriaweb/observadores/assets/img/logos_redes.png" alt="" style="width: 40rem" />
					</div>
				</div>
			</div>
		</section>
	</div>
</footer>